
import { Facet } from '../models/Facet';

export const thumbnailFacet = new Facet<{
  width: number;
  height: number;
  url: string;
}>('thumbnail');
